import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { Amplitude } from 'src/amplitude';
import { useBaseUser } from './queries/useBaseUser';

function redirectDomain(from: string, to: string) {
  Amplitude.trackUserRedirect({ from, to });
  globalThis.location.href = globalThis.location.href.replace(from, to);
}

function useRebrandRedirect() {
  const { FlagAllowRebrandRedirect } = useFlags();
  const ldClient = useLDClient();
  const { user } = useBaseUser();
  const context = ldClient?.getContext();
  const isAnonymous = Boolean(context?.anonymous);

  useEffect(() => {
    const EXPLORER_DOMAIN = import.meta.env.VITE_APP_CW_EXPLORER_DOMAIN;
    const IMAGERY_DOMAIN = import.meta.env.VITE_APP_CW_IMAGERY_DOMAIN;
    const isOnImageryDomain = globalThis.location.href.includes(IMAGERY_DOMAIN);
    const isImageryDomainSunset =
      Date.now() >= Date.parse(import.meta.env.VITE_APP_IMAGERY_DOMAIN_SUNSET);

    if (isImageryDomainSunset) {
      if (isOnImageryDomain) {
        redirectDomain(IMAGERY_DOMAIN, EXPLORER_DOMAIN);
      }
      return;
    }

    if (isAnonymous || !user?.country_code || !FlagAllowRebrandRedirect) {
      return;
    }

    if (user.country_code === 'US' && globalThis.location.href.includes(EXPLORER_DOMAIN)) {
      redirectDomain(EXPLORER_DOMAIN, IMAGERY_DOMAIN);
    }

    if (user.country_code !== 'US' && isOnImageryDomain) {
      redirectDomain(IMAGERY_DOMAIN, EXPLORER_DOMAIN);
    }
  }, [FlagAllowRebrandRedirect, user, isAnonymous]);
}

export { useRebrandRedirect };
